import { navigationDrawerStyles as drawerStyle } from "@insite/content-library/Components/NavigationDrawer";
import { ButtonWrapper } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const borderDefault = css`
    background-color: ${getColor(colorStrings.primaryMain)};
    border-color: ${getColor(colorStrings.primaryMain)};
`;

const typographyCommon: TypographyPresentationProps = {
    transform: "none",
    size: 18,
    weight: 400,
    css: css`
        &:hover {
            text-decoration: underline;
        }
    `,
};

const drawerTitleCommon = css`
    & > div > div {
        & > ${ButtonWrapper} {
            padding: 0 10px;

            &::after {
                content: none;
            }

            &:hover {
                ${borderDefault}
            }
        }
    }
`;

drawerStyle.menuTriggerButton = {
    variant: "tertiary",
    mergeCss: true,
    size: 50,
    color: colorStrings.primaryMain,
    buttonType: "solid",
    css: css`
        padding: 0;

        &&&:hover {
            ${borderDefault}
        }
    `,
};

drawerStyle.drawer = {
    ...drawerStyle.drawer,
    cssOverrides: {
        ...drawerStyle.drawer?.cssOverrides,
        drawerTitle: css`
            background-color: ${getColor(colorStrings.primaryMain)};
        `,
        titleButton: css`
            ${borderDefault}
            padding: 0 10px;

            &&&::after {
                content: none;
            }

            &&&:hover {
                ${borderDefault}
            }
        `,
    },
};

drawerStyle.drawerSectionWrapper = {
    ...drawerStyle.drawerSectionWrapper,
    css: css`
        ${drawerStyle.drawerSectionWrapper?.css}

        &:first-child {
            background: ${getColor(colorStrings.primaryMain)};

            /* stylelint-disable-next-line selector-type-case, selector-type-no-unknown */
            & > ${StyledButton}, & > [class*="PanelMenuWrapper-"] > ${StyledButton} {
                background-color: ${getColor(colorStrings.primaryMain)};
            }
        }

        & > ${StyledButton} {
            &:hover {
                ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
        }

        & > nav {
            ${drawerTitleCommon}
        }
    `,
};

drawerStyle.panelMenu = {
    ...drawerStyle.panelMenu,
    headerColor: colorStrings.primaryMain,
    childTypographyProps: {
        ...drawerStyle.panelMenu?.childTypographyProps,
        ...typographyCommon,
        color: colorStrings.secondaryMain,
    },
    cssOverrides: {
        ...drawerStyle.panelMenu?.cssOverrides,
        menu: css`
            ${drawerStyle.panelMenu?.cssOverrides?.menu}
            & > ${StyledButton} {
                background: transparent;
                width: 100%;

                &:hover {
                    text-decoration: none;

                    ${TypographyStyle} {
                        text-decoration: underline;
                    }
                }
            }
        `,
    },
    panelRowProps: {
        ...drawerStyle.panelMenu?.panelRowProps,
        css: css`
            ${drawerStyle.panelMenu?.panelRowProps?.css}

            & + div > div {
                & > ${ButtonWrapper} {
                    &::after {
                        content: none;
                    }

                    &:hover {
                        ${borderDefault}
                    }
                }
            }

            ${IconWrapper} {
                color: ${getColor(colorStrings.secondaryMain)};
            }

            &:hover {
                text-decoration: none;

                ${TypographyStyle} {
                    text-decoration: underline;
                }
            }
        `,
    },
};

drawerStyle.userRowTypography = {
    ...drawerStyle.userRowTypography,
    ...typographyCommon,
    css: css`
        ${drawerStyle.userRowTypography?.css}
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        overflow: hidden;
    `,
};

drawerStyle.mainNavigationRow = {
    ...drawerStyle.mainNavigationRow,
    css: css`
        &:hover {
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
    `,
};

drawerStyle.mainNavigationRowTypography = {
    ...drawerStyle.mainNavigationRowTypography,
    ...typographyCommon,
};

drawerStyle.logoLinks = {
    ...drawerStyle.logoLinks,
    typographyProps: {
        ...drawerStyle.logoLinks?.typographyProps,
        color: colorStrings.secondaryMain,
        ...typographyCommon,
    },
    css: css`
        ${IconWrapper} {
            color: ${getColor(colorStrings.secondaryMain)};
        }

        &:hover {
            ${TypographyStyle} {
                text-decoration: underline;
            }
        }
    `,
};

drawerStyle.currencySymbol = {
    ...drawerStyle.currencySymbol,
    color: colorStrings.secondaryMain,
};

drawerStyle.menuRowIcon = {
    ...drawerStyle.menuRowIcon,
    color: colorStrings.secondaryMain,
};

drawerStyle.signOutRowText = {
    ...drawerStyle.signOutRowText,
    ...typographyCommon,
    color: colorStrings.secondaryMain,
};
